import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
	selector: 'ng-template[aeValidationError]',
})
export class ValidationErrorDirective {
	@Input('aeValidationError') public error: string;

	constructor(public template: TemplateRef<any>) {}
}
